export default __webpack_public_path__ + "static/media/gallery_09.19e0f4a5.jpg";